import { useQuery } from '@tanstack/react-query';
import { fetchEntities } from '../services/entityService';

type EntityType = 'vc_firm' | 'angel_investor' | 'organization' | 'people_of_interest';

interface PaginatedResult {
    count: number;
    next: string | null;
    previous: string | null;
    results: unknown[];
}

const useEntitySearch = (
    entityType: EntityType, 
    query: string, 
    page: number,
    enabled = true
) => {
    return useQuery<PaginatedResult, Error>({
        queryKey: ['entities', entityType, query, page],
        queryFn: () => fetchEntities(entityType, query, page),
        enabled: enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
    });
};

export default useEntitySearch;